import dayjs from 'utils/dayjs';
import {
  DEFAULT_API_DATE_FORMAT,
  DEFAULT_MOBILE_DATE_FORMAT,
  parseDate,
  request,
} from 'utils';

import {
  FETCH_ALL_RATES_REQUEST,
  FETCH_ALL_RATES_SUCCESS,
  FETCH_ALL_RATES_FAILURE,
} from 'actionTypes';
import { currencies } from 'constants/currency';

import { dumpCurrenciesAllRates } from 'utils/dumpCurrenciesAllRates';

export const fetchCurrenciesAllTypesRates = params => async dispatch => {
  // const currentState = getState();
  const currencyList = Object.values(currencies).join(',');

  const { date = null, city = null, currency = null, locale = 'uk' } = params;
  /*
  const requestCurrencies = !currency
    ? Object.values(currencies)
    : [currency, ...currenciesInterbankList];
  console.log([...new Set(requestCurrencies)].join(','));

   */

  const requestCurrency = `base=UAH&list=${currency || currencyList}`;

  dispatch({
    type: FETCH_ALL_RATES_REQUEST,
    payload: {
      cityKey: city || 'allCities',
      dateKey: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
    },
  });

  try {
    const { data } = await request({
      url: `${process.env.APP_MINFIN_API_DOMAIN}/api/currency/simple/?${requestCurrency}`,
      params: {
        city,
        ...(date
          ? { date: parseDate(date)?.format(DEFAULT_API_DATE_FORMAT) }
          : {}),
      },
    });

    return dispatch({
      type: FETCH_ALL_RATES_SUCCESS,
      payload: {
        cityKey: city || 'allCities',
        dateKey: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
        entities: dumpCurrenciesAllRates(data, locale),
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_ALL_RATES_FAILURE,
      payload: {
        cityKey: city || 'allCities',
        dateKey: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
      },
    });
  }
};
